
import { useAuthService } from "~/composables/useAuthService";
import { useRuntimeConfig } from "#app";

export function useHttpRequest() {
  const config = useRuntimeConfig().public.atomNuxt;
  const { accessToken, impersonatingAccessToken, logout } = useAuthService();
  const { setAlertMessage } = useAlertService();
  const { stringifyQuery, flattenQuery } = useCrudConverters();

  const httpRequest = async (endpoint, data) => {
    var headers = {
      Accept: 'application/json',
    };

    if (endpoint.requiresAuth) {
      if (impersonatingAccessToken.value != null && impersonatingAccessToken.value.length > 10) {
        headers.Authorization = "Bearer " + impersonatingAccessToken.value;
      } else {
        headers.Authorization = "Bearer " + accessToken.value;
      }
    }

    try {
      let url = `${config.apiBaseUrl}${endpoint.path}`;
      let options = {
        method: endpoint.method.toUpperCase(),
        headers: headers,
      };

      if (endpoint.method === 'post' || endpoint.method === 'put') {
        options.body = JSON.stringify(data);
        headers['Content-Type'] = 'application/json';
      }

      if (endpoint.method === 'get' && data && Object.keys(data).length > 0) {
        const queryString = stringifyQuery(flattenQuery(data));
        url += `?${queryString}`;
      }

      const response = await fetch(url, options);

      if (!response.ok) {
        throw response;
      }

      const responseData = await response.json();

      if (response.headers.get('user-message')) {
        setAlertMessage(response.headers.get('user-message'));
      }

      return responseData;
    } catch (e) {
      if (e.status === 401) {
        await logout();
      }
      const responseData = await e.json();
      throw responseData;
    }
  };

  return { httpRequest };
}


